import axios from "axios";

const BALLPARK_BACKEND_BASE_URL = import.meta.env.VITE_BALLPARK_API_URL;

export const getAthleteUserById = (id, user) => {
  let headers = {
    "Content-Type": "application/json",
    Authorization: "Bearer " + user.stsTokenManager.accessToken,
  };

  return axios.get(BALLPARK_BACKEND_BASE_URL + "getUserById?id=" + id, {
    headers,
  });
};

export const searchStudentAthleteByName = (name, user) => {
  let headers = {
    "Content-Type": "application/json",
    Authorization: "Bearer " + user.stsTokenManager.accessToken,
  };

  return axios.get(
    BALLPARK_BACKEND_BASE_URL + "searchForStudentAthlete?search=" + name,
    {
      headers,
    }
  );
};
